export default "__VITE_ASSET__1193ba4f__"